import { render } from "./AddCreditVoucher.vue?vue&type=template&id=5631c6ac"
import script from "./AddCreditVoucher.vue?vue&type=script&lang=js"
export * from "./AddCreditVoucher.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__